import React from "react"
import {Spinner} from "reactstrap"

const ProgressView = () =>   <Spinner className="ms-2" color="primary" />

export default ProgressView